
import api from "../../../../../api/api"

const getList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/party").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getDD = () =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/dd/party").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getById = (id,allData = false) =>{
    return new Promise((resolve, reject)=>{
       api.get("erp/party/" + id, {
            params: { allData: allData ? true : undefined }
        }).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const searchByPhone = (phone) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/party/phone/"+phone).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const save = (payload) => {
    return new Promise((resolve, reject) => {
        // 1. Determine the method dynamically
        const method = payload.id ? "put" : "post";
        api[method]("erp/party", payload).then((res) => {
            if (!res.data.error) {
                resolve(res.data);
            } else {
                reject({ msg: res.data.msg });
            }
        })
        .catch((error) => {
            reject({
                msg: "Something Went Wrong",
                error: error
            });
        });
    });
};

const remove = (id) => {
    return new Promise((resolve, reject)=>{
        api.delete("erp/party/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const partyServices = {
    getList,
    getDD,
    getById,
    searchByPhone,
    save,
    remove,
}
export default partyServices;